import { environment } from 'src/environments/environment';
export const Constantes = {

    ABIERTO: 'ABIERTO',
    OBSERVACIONES: 'OBSERVACIONES',
    PROCESO: 'PROCESO',
    RESUELTO: 'RESUELTO',
    REVISION: 'REVISION',
    VOBO: 'VOBO',
    CANCELADO: 'CANCELADO',
  
    ABIERTOCOLOR: '#26a69a',
    OBSERVACIONESCOLOR: '#ff9800',
    PROCESOCOLOR: '#2196f3',
    RESUELTOCOLOR: '#916EFF',
    REVISIONCOLOR: '#3C4858',
    VOBOCOLOR: '#e91e63',
    CANCELADOCOLOR: '#999999',
    /**TICKETS(SEMÁFORO) */
    GREEN: 'green',
    YELLOW: 'yellow',
    RED: 'red',
    PINK: 'pink',
    ENTIEMPO: 'En Tiempo',
    ADESTIEMPO: 'A destiempo',
    FUERADETIEMPO: 'Fuera de Tiempo',
    DIEZ: 10,
    VEINTE: 20,
    CINCUENTA: 50,
    CIEN: 100,
    MIL: 1000,
    CERO: 0,
    UNO: 1,
    CINCO: 5,
    VACIO: '',
    SPACE: ' ',
    EXITO: '00000',
    SEPARATOR: '¬',
    SEPARATOR_VALUE: '|',
    FILTRO_CODIGO: 'codigo',
    FILTRO_FOLIO: 'folio',
    FILTRO_NOMBRE: 'nombre',
    FILTRO_ID: 'id',
    FILTRO_FECHA: 'fechaActualiza',
    ELEMENTO: 'elemento',
    FLUJO: 'flujo',
    FACTORY: 'factory',
    TAMANIO_DIALOG: '350',
    CAJA: 'caja',
    VENTA: 'venta',
    MXP: 'MXP',
    USD: 'USD',
    EMPRESA_DEFAULT: 1,
      CORPORATIVO_DEFAULT: 1001,
      UNO_NEGATIVO: -1,
      UNO_STR: '1',
      DOS: 2,
      DOS_STR: '2',
      TRES: 3,
      CUATRO: 4,
      SEIS: 6,
      SIETE: 7,
      OCHO: 8,
      NUEVE: 9,
      EMPTY: '',

  };
  